import { parsePhoneNumberFromString, type CountryCode } from 'libphonenumber-js'

// Romania is the primary market, so a number typed without a prefix
// ("0712 345 678") is read as Romanian. Anything else needs its "+".
const DEFAULT_COUNTRY: CountryCode = 'RO'

/**
 * A phone number in E.164 ("+40712345678"), or null when it is not a real one.
 *
 * One format in the database, however the member typed it: the gym calls and
 * exports these, and "0712 345 678", "+40 712-345-678" and "0040712345678" are
 * the same phone.
 */
export function normalizePhone(
  value: string,
  defaultCountry: CountryCode = DEFAULT_COUNTRY,
): string | null {
  const parsed = parsePhoneNumberFromString(value.trim(), defaultCountry)
  return parsed?.isValid() ? parsed.number : null
}

export function isValidPhone(value: string): boolean {
  return normalizePhone(value) !== null
}
